<template>
  <div class="flex items-start">
    <div class="vx-row w-full">
      <div class="vx-col sm:w-1/2 w-full mb-6">
        <vs-input
          class="w-full"
          label="Широта:"
          name="latitude"
          type=""
          v-validate="'required|decimal'"
          :class="isEditedClass(latitude, template.additional_data['location.latitude'])"
          v-model="latitude"
        />
        <span class="text-danger text-sm" v-show="errors.has('latitude')">{{ errors.first('latitude') }}</span>
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-6">
        <vs-input
          class="w-full"
          label="Долгота:"
          name="longitude"
          type=""
          v-validate="'required|decimal'"
          :class="isEditedClass(longitude, template.additional_data['location.longitude'])"
          v-model="longitude"
        />
        <span class="text-danger text-sm" v-show="errors.has('longitude')">{{ errors.first('longitude') }}</span>
      </div>
      <div class="vx-col w-full">
        <vs-input
          class="w-full"
          label="Адрес:"
          name="address"
          v-validate="'required'"
          :class="isEditedClass(address, template.additional_data['location.address'])"
          v-model="address"
        />
        <span class="text-danger text-sm" v-show="errors.has('address')">{{ errors.first('address') }}</span>
      </div>
    </div>
    <TemplateButtons
      :show-save-button="isReadyToSave"
      @save="handleClickOnSave"
      @delete="handleClickOnDelete"
    />
  </div>
</template>

<script>
import TemplateButtons from './TemplateButtons'
import { isEditedClass } from '../../../../helpers/helpers'

export default {
  props: {
    template: {
      type: Object,
      required: true
    }
  },
  components: {
    TemplateButtons
  },
  data () {
    return {
      latitude: this.template.additional_data['location.latitude'],
      longitude: this.template.additional_data['location.longitude'],
      address: this.template.additional_data['location.address']
    }
  },
  computed: {
    isReadyToSave () {
      return (
        this.latitude !== this.template.additional_data['location.latitude'] ||
        this.longitude !== this.template.additional_data['location.longitude'] ||
        this.address !== this.template.additional_data['location.address']
      )
    }
  },
  methods: {
    isEditedClass,
    async handleClickOnSave () {
      const validate = await this.$validator.validateAll()
      if (validate) {
        this.$emit('save', {
          id: this.template.id,
          new: this.template.new || false,
          message_type: 'location',
          additional_data: {
            'location.latitude': this.latitude,
            'location.longitude': this.longitude,
            'location.address': this.address
          }
        })
      }
    },
    async handleClickOnDelete () {
      this.$emit('delete', {
        id: this.template.id,
        new: this.template.new || false
      })
    }
  }
}
</script>
